import React, { memo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { EmojiPicker, Icon } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import { insertStringAtUtf16Index } from '../../utils/utf16SafeInsert';

const EmojiInsertButton = memo(({ onChange, cursorPosition, value, getValue }) => {
    const [visible, setVisible] = useState(false);

    const insertAtCursor = useCallback(
        (insertValue) => {
            const currentValue = getValue?.() ?? value ?? '';
            return insertStringAtUtf16Index(currentValue, cursorPosition, insertValue);
        },
        [cursorPosition, getValue, value],
    );

    const handleInsertEmoji = useCallback(
        (emojiItem) => {
            if (!emojiItem?.emoji) {
                return;
            }

            onChange?.(insertAtCursor(emojiItem.emoji));
            setVisible(false);
        },
        [insertAtCursor, onChange],
    );

    return (
        <EmojiPicker
            popoverVisible={visible}
            onVisibleChange={setVisible}
            onSelectEmoji={(_name, selectedEmoji) => handleInsertEmoji(selectedEmoji)}
        >
            <button
                type="button"
                className="textarea-field-insert__btn"
                aria-label={getLiteral('label_emoji')}
            >
                <Icon name="moodSmall" />
            </button>
        </EmojiPicker>
    );
});

EmojiInsertButton.displayName = 'EmojiInsertButton';

EmojiInsertButton.propTypes = {
    onChange: PropTypes.func,
    cursorPosition: PropTypes.number.isRequired,
    value: PropTypes.string,
    getValue: PropTypes.func,
};

export default EmojiInsertButton;
